export interface Budget {
  id: string;
  userId: string;
  categoryId: string | null;
  categoryName: string | null;
  name: string;
  amount: number;
  spent: number;
  period: 'monthly' | 'yearly';
  startDate: string;
  endDate: string | null;
  alertThreshold: number; // percentage (e.g., 80 means alert at 80%)
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BudgetsListResponse {
  budgets: Budget[];
  total: number;
  summary: {
    totalBudgeted: number;
    totalSpent: number;
    overBudgetCount: number;
  };
}

export interface CreateBudgetInput {
  categoryId?: string | null;
  name: string;
  amount: number;
  period: 'monthly' | 'yearly';
  alertThreshold?: number;
}

export interface UpdateBudgetInput extends Partial<CreateBudgetInput> {
  isActive?: boolean;
}

export function getBudgetStatus(spent: number, amount: number): 'safe' | 'warning' | 'danger' {
  const percentage = (spent / amount) * 100;
  if (percentage >= 100) return 'danger';
  if (percentage >= 80) return 'warning';
  return 'safe';
}

export function formatBudgetProgress(spent: number, amount: number): string {
  const percentage = Math.min((spent / amount) * 100, 100);
  return `${percentage.toFixed(0)}%`;
}
